const getNames = (name: string) => {
  if (name === 'name') {
    return ['lastName', 'firstName']
  }
  if (name === 'address') {
    return ['postal', 'addressCity', 'addressHomeNumber', 'addressBuildingName']
  }
  if (name === 'resume') {
    return ['resumeFile', 'resumeUrl']
  }
  if (name === 'skillSheet') {
    return ['skillSheetFile', 'skillSheetUrl']
  }
  if (name === 'portfolio') {
    return ['portfolioFile', 'portfolioUrl']
  }

  return [name]
}

export default getNames
